import { SecondaryButton } from '../../../components/SecondaryButton';
import useGetGeneralAppData from '../../../hooks/useGetGeneralAppData';
import ExportXlsx from '../../../utils/ExportXlsx';
import getTodayDate from '../../../utils/getTodayDate';
import { CsvParsedType } from '../types';

interface DownloadGeneralCsvInterface {
  dataList: CsvParsedType[];
}

export default function DownloadGeneralCsv({ dataList }: DownloadGeneralCsvInterface) {
  const { companyName } = useGetGeneralAppData();

  return (
    <SecondaryButton onClick={() => {
      ExportXlsx({
        data: dataList,
        filename: `Arquivo geral de triangulação ${companyName} ${getTodayDate()}`,
      });
    }}
    >
      Download CSV
    </SecondaryButton>
  );
}
